import { reviewBodySchema } from "@redotech/redo-review-db-schema/review-body-schema";
import * as z from "zod";

export const getReviewById = {
  name: "getReviewById" as const,
  input: z.object({ reviewId: z.string(), email: z.string().email() }),
  output: reviewBodySchema.nullable(),
};
